<template>
  <section class="banner" id="final">
    <figure>
      <img alt="banner" src="../assets/img/fim.jpg" />
    </figure>
    <ul class="banner__list">
      <li>
        <p>Apresentado por:</p>
        <a href="https://jbs.com.br/" target="_blank">
          <img src="../assets/img/logo_jbs_white.svg" alt="" />
        </a>
      </li>
      <li>
        <p>Produção:</p>
        <a href="http://bluestudio.estadao.com.br/" target="_blank">
          <img src="../assets/img/logo_bluestudio-white.svg" alt="" />
        </a>
      </li>
      <li>
        <p>Realização:</p>
        <a href="https://www.estadao.com.br/" target="_blank">
          <img src="../assets/img/logo_estadão_white.svg" alt="" />
        </a>
      </li>
    </ul>
    <div class="banner__text">
      <img
        alt="70 anos alimentando o que alimenta o mundo."
        src="../assets/img/70.svg"
        class="banner__text__titulo"
      />
      <div class="banner__text__button">
        <a href="https://jbs.com.br/" target="_blank">Saiba mais</a>
      </div>
      <div class="banner__ads">
        <dfp-slot
          path="/118650305/patrocinados/jbs"
          :size="[
            [970, 90],
            [728, 90],
            [970, 250],
          ]"
          id="div-gpt-ad-1664301080980-0"
          class="desktop"
        />
        <dfp-slot
          path="/118650305/patrocinados/jbs"
          :size="[320, 100]"
          id="div-gpt-ad-1664301825759-0"
          class="mobile"
        />
      </div>
    </div>
  </section>
</template>

<script>
import DfpSlot from './DfpSlot.vue';
export default {
  components: { DfpSlot },
};
</script>

<style scoped lang="scss">
.banner {
  position: relative;
  z-index: 200;
  figure {
    img {
      width: 100%;
      height: 100vh;
      object-fit: cover;
      margin-block: -4px;
      @include media('>desktop') {
        min-height: 850px;
      }
    }
  }
  &__ads {
    display: block;
    text-align: center;
    width: 100%;
    .desktop {
      @include media('<=desktop') {
        display: none;
      }
    }
    .mobile {
      display: none;
      @include media('<=desktop') {
        display: block;
      }
    }
  }
  &__text {
    position: absolute;
    left: 0;
    top: 150px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 100px;
    gap: 100px;
    @include media('<=desktop') {
      gap: 0;
    }
    &__button {
      @include media('<=desktop') {
        width: 100%;
      }
      a {
        width: 10rem;
        height: 3.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: font(primary);
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: color(cWhite);
        background: transparent;
        margin: 2rem auto;
        border-radius: 5.3125rem;
        text-decoration: none;
        transition: 0.3s ease-in-out;
        position: relative;
        border: 1px solid color(cWhite);
        strong {
          font-weight: 800;
        }

        &:hover {
          background: color(cRed);
          border-color: color(cRed);
        }
      }
    }
    &__titulo {
      @include media('<=desktop') {
        max-width: 300px;
      }
    }
  }
  &__list {
    position: absolute;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    list-style: none;
    display: flex;
    justify-content: center;
    gap: 3.2rem;
    p {
      color: color(cWhite);
      font-family: font(secondary);
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-bottom: 1rem;
    }

    a {
      display: block;
      text-align: center;
    }
  }
}

@keyframes rotateText {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
